import { render, staticRenderFns } from "./aiLandSelect.vue?vue&type=template&id=521e00ac&scoped=true&"
import script from "./aiLandSelect.vue?vue&type=script&lang=js&"
export * from "./aiLandSelect.vue?vue&type=script&lang=js&"
import style0 from "./aiLandSelect.vue?vue&type=style&index=0&id=521e00ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e00ac",
  null
  
)

export default component.exports